import { setContext } from '@apollo/client/link/context';

import { AUTHORIZATION_HEADER_VALUE_PREFIX } from '@/core/constants/auth';
import { useAuthStore } from '@/core/store/auth/authStore';

import { namedOperations } from '../../generated/namedOperations';

export const authLink = setContext(({ operationName }, { headers }) => {
	const token = useAuthStore.getState().idToken;

	if (
		operationName === namedOperations.Mutation.RefreshToken ||
		operationName === namedOperations.Mutation.InitiateAuth ||
		operationName === namedOperations.Mutation.PasswordSignIn
	) {
		return {
			credentials: 'include',
			headers: {
				...headers
			}
		};
	}

	return {
		credentials: 'include',
		headers: {
			...headers,
			authorization: token
				? `${AUTHORIZATION_HEADER_VALUE_PREFIX} ${token}`
				: ''
		}
	};
});
